'use strict';

exports.__esModule = true;

var _react = require('react');

exports.default = _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-leaflet/lib/types/children.js
 ** module id = 33
 ** module chunks = 0
 **/